import utils from '../../assets/js/utils'
export default {
  className: 'trip',
  fields: [
    {
      name: 'direction',
      note: '方向',
      width: 150
    },
    {
      name: 'mode',
      width: 150
    },
    // {
    //   name: 'region',
    //   width: 150
    // },
    {
      name: 'startPlace',
      width: 200,
      render (record) {
        return `${record.startPlace.city}-${record.startPlace.district}-${record.startPlace.title}`
      }
    },
    {
      name: 'endPlace',
      width: 200,
      render (record) {
        return `${record.endPlace.city}-${record.endPlace.district}-${record.endPlace.title}`
      }
    },
    {
      name: 'travelTime'
    },
    {
      name: 'passengers',
      width: 150,
      render (record) {
        return `${record.passengers}人`
      }
    },
    {
      name: 'phone',
      width: 150
    },
    // {
    //   name: 'confirmStatus',
    //   width: 200
    // },
    {
      name: 'remarks',
      width: 200
    }
  ],
  search: [
    'direction',
    // 'mode',
    'travelTime',
    'passengers',
    'phone'
    // 'confirmStatus'
  ],
  action: {
    export: false,
    create: false,
    delete: false,
    edit: false,
    // confirm: {
    //   type: 'row',
    //   text: '确认',
    //   hidden ({ record }) {
    //     return record && record.confirmStatus === 'confirm'
    //   },
    //   callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
    //     await vm.confirm('警告', '您要确认该行程吗?')
    //     let rs = await vm.$modelAjax.put(modelName, record.objectId, { confirmStatus: 'confirm' }).catch(() => {
    //       this.$notification['error']({
    //         message: '网络错误',
    //         description: '确认失败'
    //       })
    //     })
    //     if (rs) {
    //       vm.$notification['success']({
    //         message: '操作成功',
    //         description: '确认成功'
    //       })
    //       vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
    //     }
    //   }
    // },
    dispatch: {
      type: 'row',
      text: '派车',
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '您确定要派车吗?')
        let rs = await vm.$modelAjax.put(modelName, record.objectId, { status: 'complete', confirmStatus: 'confirm' }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '派车失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '派车成功'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }
    },
    copy: {
      type: 'row',
      text: '复制',
      callback: async ({ record, vm, modelName }) => {
        utils.copy(record, vm)
      }
    },
    cancel: {
      type: 'row',
      text: '取消',
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '你确定要取消这个订单吗?')
        let rs = await vm.$modelAjax.put(modelName, record.objectId, { status: 'cancel' }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '取消失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '订单已取消'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.status = 'wait'
    }
  }
}
